import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

const TopPanelContainer = _styled("div", {
  target: "e7bb2ws0",
  label: "TopPanelContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1dch70s",
  styles: "display:flex;margin:0 0 24px 10px;"
} : {
  name: "1dch70s",
  styles: "display:flex;margin:0 0 24px 10px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9BZGRvbkRpc2NvdmVyeS9jb21wb25lbnRzL2NvbW1vbi9Ub3BQYW5lbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRb0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL0FkZG9uRGlzY292ZXJ5L2NvbXBvbmVudHMvY29tbW9uL1RvcFBhbmVsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBSZWFjdCwgeyBQdXJlQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgdHlwZSB7IE5vZGUgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IFRvcFBhbmVsQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgbWFyZ2luOiAwIDAgMjRweCAxMHB4O1xuYDtcblxudHlwZSBQcm9wcyA9IHtcbiAgdG9wUGFuZWw6ID9Ob2RlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVG9wUGFuZWwgZXh0ZW5kcyBQdXJlQ29tcG9uZW50PFByb3BzPiB7XG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgdG9wUGFuZWw6IFByb3BUeXBlcy5ub2RlLFxuICB9O1xuXG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gdGhpcy5wcm9wcy50b3BQYW5lbCA/IChcbiAgICAgIDxUb3BQYW5lbENvbnRhaW5lcj57dGhpcy5wcm9wcy50b3BQYW5lbH08L1RvcFBhbmVsQ29udGFpbmVyPlxuICAgICkgOiBudWxsO1xuICB9XG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default class TopPanel extends PureComponent {
  render() {
    return this.props.topPanel ? /*#__PURE__*/React.createElement(TopPanelContainer, null, this.props.topPanel) : null;
  }

}

_defineProperty(TopPanel, "propTypes", {
  topPanel: PropTypes.node
});